// @flow

import React from 'react';
import EmptyComponent from './emptyComponent';

const withErrorEmptyComponent = (error: string) => (
  (props: any) => (
    <EmptyComponent {...props} error={error} />
  )
);

export default withErrorEmptyComponent;
